import { Mail, Phone, MapPin, Banknote, TrendingUp, Clock, HandCoins,BriefcaseBusiness  } from "lucide-react";
import { FaLinkedinIn } from "react-icons/fa";

export const contact = [
  {
    key: "email",
    title: "Email",
    Icon: Mail,
    iconBg: "#666666",
    iconColor: "#C24471",
  },
  {
    key: "phone",
    title: "Phone",
    Icon: Phone,
    iconBg: "#666666",
    iconColor: "#0083FF",
  },
  {
    key: "location",
    title: "Location",
    Icon: MapPin,
    iconBg: "#666666",
    iconColor: "#6DAF81",
  },
  {
    key: "linkedin",
    title: "LinkedIn",
    Icon: FaLinkedinIn,
    iconBg: "#666666",
    iconColor: "#0A66C2",
    isLink: true,
  },
];

export const salaryFields = [
  {
    key: "current_salary",
    label: `Gross Salary`,
    format: (v,currencySign) => `${currencySign}${Number(v).toLocaleString("en-IN")}`,
    gradient: "linear-gradient(135deg, #C24471 0%, transparent 60%)",
    Icon: Banknote,
    iconBg: "#FFDEEA",
    iconColor: "#C24471",
  },
  {
    key: "expected_salary",
    label: `Expected Gross Salary`,
    format: (v,currencySign) => `${currencySign}${Number(v).toLocaleString("en-IN")}`,
    gradient: "linear-gradient(135deg, #0083FF 0%, transparent 60%)",
    Icon: HandCoins,
    iconBg: "#BFE0FF",
    iconColor: "#0083FF",
  },
  {
    key: "total_experience",
    label: "Total Experience",
    format: (v) => `${Number(v).toLocaleString("en-IN")} years`,
    gradient: "linear-gradient(135deg, #B200ED 0%, transparent 60%)",
    Icon: BriefcaseBusiness,
    iconBg: "#D7BFDC",
    iconColor: "#B200ED",
  },
  {
    key: "hike", // ← computed, not from backend
    label: "Expected Hike",
    format: (cur, exp) => {
      const hike = ((exp - cur) / cur) * 100;
      return `${hike >= 0 ? "+" : ""}${hike.toFixed(1)}%`;
    },
    gradient: "linear-gradient(135deg, #6DAF81 0%, transparent 60%)",
    Icon: TrendingUp,
    iconBg: "#DFFFE9",
    iconColor: "#6DAF81",
  },
  {
    key: "notice_period",
    label: "Notice Period",
    format: (v) => v,
    gradient: "linear-gradient(135deg, #6DAF81 0%, transparent 60%)",
    Icon: Clock,
    iconBg: "#DFFFE9",
    iconColor: "#6DAF81",
  },
];
 